import { action } from 'satcheljs';
import type { DragData } from 'owa-dnd/lib/utils/dragDataUtil';

export const launchFullComposeFromDropData = action(
    'launchFullComposeFromDropData',
    (dragData: DragData) => ({
        dragData,
    })
);
